import { render, staticRenderFns } from "./StockviewCheckboxFilter.vue?vue&type=template&id=28297064&scoped=true&"
import script from "./StockviewCheckboxFilter.vue?vue&type=script&lang=js&"
export * from "./StockviewCheckboxFilter.vue?vue&type=script&lang=js&"
import style0 from "./StockviewCheckboxFilter.vue?vue&type=style&index=0&id=28297064&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28297064",
  null
  
)

export default component.exports